<template>
  <section class="">
    <el-row class="">
      <el-col :span="10" class="">
        <div class="">
          <img
            alt="forgot"
            class="forgot-pass-bg mobile"
            src="../../../assets/images/mobile/forgot_pass_mobile.png"
          />
          <img
            alt="forgot"
            class="forgot-pass-bg desktop"
            src="../../../assets/images/forgot_pass.png"
          />
        </div>
      </el-col>
      <el-col class="form-wrapper">
        <h2 class="form-wrapper__title" v-if="phoneStep">Забули пароль?</h2>
        <p class="form-wrapper__text" v-if="phoneStep">
          Введіть номер телефону, який використовувався для реєстрації, і ми
          допоможемо його згадати
        </p>
        <el-form>
          <el-row :gutter="20" class="form-row" v-if="phoneStep">
            <el-col :md="12">
              <el-form-item class="your-phone-wrapper custom-form-input">
                <el-input
                  v-model="phone"
                  type="tel"
                  minlength="10"
                  maxlength="10"
                  placeholder=""
                  ><template slot="prepend">+38</template></el-input
                >
                <div class="your-label">ваш телефон</div>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <button
                type="button"
                class="rounded-btn blue"
                :disabled="loading || phone.length < 10"
                @click="sendPhoneNumber"
              >
                Відправити
              </button></el-col
            >
          </el-row>
          <el-row
            v-else
            class="form-row code-password-step"
            type="flex"
            justify="center"
          >
            <h2 class="">Введіть код з смс та Ваш новий пароль</h2>
            <el-col>
              <el-row type="flex" :gutter="15" align="center">
                <el-col :md="12">
                  <el-form-item class="custom-form-input">
                    <el-input
                      type="text"
                      maxlength="6"
                      v-model="code"
                      placeholder=""
                    />
                    <div class="your-label">код з sms</div>
                  </el-form-item>
                </el-col>
                <el-col :md="12">
                  <el-form-item
                    class="custom-form-input"
                    :class="{ invalid: $v.password.$error }"
                  >
                    <el-input type="text" v-model="password" placeholder="" />
                    <div class="your-label">новий пароль</div>
                    <small
                      class="input-error"
                      :class="{
                        invalid: $v.password.$error && !$v.password.required,
                      }"
                      >Поле пароль обов'язкове</small
                    >
                    <small
                      class="input-error"
                      :class="{
                        invalid:
                          $v.password.$error &&
                          !$v.password.minlength &&
                          $v.password.required,
                      }"
                      >Пароль має бути не менше
                      {{ $v.password.$params.minLength.min }} символів</small
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <button
              type="button"
              class="rounded-btn blue"
              :disabled="loading || code.length < 6 || password.length < 8"
              @click="sendCodePassword"
            >
              Відправити
            </button>
          </el-row>
        </el-form>
        <button class="transparent-btn go-back-btn" @click="$emit('go-back')">
          <IconBase
            height="10"
            width="10"
            style="stroke: #5ac2f2; transform: rotate(180deg)"
          >
            <ArrowRight />
          </IconBase>
          <span style="padding-left: 1.2rem">Повернутись назад</span>
        </button>
      </el-col>
    </el-row>
  </section>
</template>
<script>
import { minLength, required } from 'vuelidate/lib/validators'
import ArrowRight from '@/components/icons/ArrowRight'
import IconBase from '@/components/icons/IconBase'

export default {
  name: 'ForgotPasswordPopUp',
  components: { IconBase, ArrowRight },
  data() {
    return {
      code: '',
      phone: '',
      password: '',
      phoneStep: true,
      loading: false,
    }
  },
  validations: {
    password: { minLength: minLength(8), required },
  },
  methods: {
    async sendPhoneNumber() {
      try {
        this.loading = true
        await this.$store.dispatch('forgotPasswordSMS', {
          phone: '+38' + this.phone,
        })
        this.phoneStep = false
      } catch (e) {
        this.$errorMessage('Упс... Схоже номер вказано не вірно')
      } finally {
        this.loading = false
      }
    },
    async sendCodePassword() {
      try {
        this.$v.password.$touch()
        if (this.$v.password.$invalid) {
          return
        }
        this.loading = true
        await this.$store.dispatch('resetPassword', {
          code: this.code,
          phone: '+38' + this.phone,
          password: this.password,
          password_confirmation: this.password,
        })
        this.$emit('close')
        this.$v.password.$reset()
        this.$successMessage('Пароль успішно змінено!')
      } catch (e) {
        this.$errorMessage('Упс... Код з sms вказано не вірно')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
